// MF-67 — Delete confirmation for the journal lists, on the app's standard DialogConfirm so it
// matches the confirm/cancel dialogs used elsewhere. Nothing is deleted until the user confirms.
import DialogConfirm from '../../../dialog/DialogConfirm'
import { Typography, Alert } from '@mui/material'

const ConfirmDelete = ({
  open,
  entity = 'item',
  name = '',
  loading = false,
  error = '',
  onCancel,
  onConfirm
}) => (
  <DialogConfirm
    id={`journal-delete-${entity}`}
    open={open}
    onCancel={onCancel}
    onConfirm={onConfirm}
    loading={loading}
    title='Delete'
    textConfirm='Delete'
    onCloseHeader
    maxWidth='xs'
  >
    <Typography component='div'>
      Are you sure you want to delete the {entity} {name ? <b>{name}</b> : null}? This can&apos;t be undone.
    </Typography>
    {error ? (
      <Alert type='error' className='mt-2'>
        {error}
      </Alert>
    ) : null}
  </DialogConfirm>
)

export default ConfirmDelete
